export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_Shopify-f384daca4e641ca6985098974f1299b6.jpg";